import React, {Component} from 'react';
import SummaryChart from "../SummaryChart";
import {compose} from "redux";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {getSubmittalStatusReport} from "../../../actions/reports";
import {buildSummaryChartData} from "../../../projections";
import * as PropTypes from "prop-types";
import {subdocumentStatusReportSelector} from "../selectors";

class SubmittalSummary extends Component {
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  render() {
    const { summary, title, onClick } = this.props;
    const chartData = buildSummaryChartData(summary);
    return (
      <SummaryChart
        title={title}
        data={chartData}
        onClick={onClick}
      />
    );
  }
}

SubmittalSummary.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default compose(
  withRouter,
  connect(
    (state, props) => ({
      summary: subdocumentStatusReportSelector(state, { path: 'submittals', code: 'submittalstatus' })
    }),
    (dispatch, props) => ({
      onMount: () => dispatch(getSubmittalStatusReport({id: props.match.params.id}))
    })
  )
)(SubmittalSummary);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/SubmittalSummary.js